export class AlkLocalPersistence {
    constructor() {
        throw 'no instanciation allowed';
    }
}
AlkLocalPersistence.clear = () => AlkLocalPersistence.storage.clear();
AlkLocalPersistence.getItem = (key) => AlkLocalPersistence.storage.getItem(key);
AlkLocalPersistence.removeItem = (key) => AlkLocalPersistence.storage.removeItem(key);
AlkLocalPersistence.setItem = (key, value) => AlkLocalPersistence.storage.setItem(key, value);
AlkLocalPersistence.hasItem = (key) => Boolean(AlkLocalPersistence.storage.getItem(key));
AlkLocalPersistence.storage = localStorage;
